export default {
  root: ({ props }) => ({
    class: [
      'inline-block relative',
      'w-12 h-7',
      'rounded-2xl',
      {
        'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
      },
    ],
  }),
  slider: ({ props, instance }) => ({
    class: [
      // Position
      'absolute top-0 left-0 right-0 bottom-0 w-full',
      { 'before:transform before:translate-x-5': instance.$attrs['checked'] == props.trueValue },

      // Shape
      'rounded-2xl',

      // Before:
      'before:absolute before:top-[11px] before:left-px',
      'before:-mt-2.5',
      'before:h-6 before:w-6',
      'before:rounded-full',
      'before:duration-200',
      'before:bg-white',

      // Colors
      'border',
      {
        'bg-brand-greyscale-neutral-600':
          instance.$attrs['checked'] !== props.trueValue && !props.disabled,
        'bg-blue-600': instance.$attrs['checked'] === props.trueValue && !props.disabled,
      },

      { 'border-transparent': !props.invalid },

      // Invalid State
      { 'border-red-500': props.invalid },

      // States
      {
        'bg-brand-greyscale-neutral-300':
          instance.$attrs['checked'] !== props.trueValue && props.disabled,
      },
      {
        'bg-brand-greyscale-neutral-400':
          instance.$attrs['checked'] === props.trueValue && props.disabled,
      },
      'peer-focus-visible:ring peer-focus-visible:ring-primary-400/50',

      // Transition
      'transition-colors duration-200',

      // Misc
      'cursor-pointer',
    ],
  }),
  input: {
    class: [
      'peer',

      // Size
      'w-full ',
      'h-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded-[2.5rem]',
      'outline-none',

      // Misc
      'appearance-none',
      'cursor-pointer',
    ],
  },
};
